<template>
  <div class="home">
    <v-container>
      <v-layout>
        <v-tabs>
          <v-tab to="/feeds/chat" class="text-none">Chat Feed</v-tab>
        </v-tabs>
      </v-layout>
      <v-divider />
      <router-view />
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
